<template>
  <div>
    <v-card>
      <v-data-table
          dense
          :headers="columns"
          :items="filteredItems()"
          item-key="human_user.employee_number"
          class="elevation-1"

          :options.sync="options"
          :server-items-length="totalRecords"
          @update:options="updateOptions"

          :loading="loading"
          :height="windowHeight"
          :item-class="itemRowBackground"
          fixed-header
          hide-default-footer
          hide-default-header
      >
        <template v-slot:item.user="{ item }">
<!--          <TimeTrackerHumanInfoModal :item="item"></TimeTrackerHumanInfoModal>-->
          <v-chip class="font-weight-bold text-h6 my-1">{{ item.human_user.user }}</v-chip>
        </template>
        <template v-slot:item.employee_number="{ item }">
          <v-chip>{{ item.human_user.employee_number }}</v-chip>
        </template>
        <template v-slot:item.floor="{ item }">
          <v-chip v-if="item.floor">{{ item.floor }}</v-chip>
        </template>
        <template v-slot:item.start="{ item }">
          <TimeTrackerEnterEvent
              :item="item" color="green darken-2" event="tracker start" title="Start"
              width="70"
              v-if="item.btn_work_start === true"
          ></TimeTrackerEnterEvent>
          <TimeTrackerEnterEventConfirm
              :item="item" color="red darken-2" event="tracker stop" title="Stop"
              width="70"
              v-else-if="item.btn_work_stop === true"
          ></TimeTrackerEnterEventConfirm>
        </template>
        <template v-slot:item.pause="{ item }">
          <TimeTrackerEnterEvent
              :item="item" color="blue darken-2" event="pause start" title="Pause start"
              v-if="item.btn_pause_start === true"
          ></TimeTrackerEnterEvent>
          <TimeTrackerEnterEvent
              :item="item" color="yellow darken-2" event="pause stop" title="Pause stop"
              v-else-if="item.btn_pause_stop === true"
          ></TimeTrackerEnterEvent>
        </template>
      </v-data-table>

      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        color="error"
        centered
        elevation="10"
        vertical
      >
        {{ message_error }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>

    </v-card>
    <router-view></router-view>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEnterEvent from "@/components/TimeTracker/TimeTrackerEnterEvent";
import TimeTrackerEnterEventConfirm from "@/components/TimeTracker/TimeTrackerEnterEventConfirm";
import TimeTrackerHumanInfoModal from "@/components/TimeTracker/TimeTrackerHumanInfoModal";


export default {
  name: 'TimeTrackerFloorTable',
  props: {
    subtractHeight: {type: [Number], default: 50},
    height: {type: [Number], default: window.innerHeight},
    floor: {type: [Number], default: null},
    title: {type: [String], default: null},
  },

  components: {
    TimeTrackerEnterEvent,
    TimeTrackerEnterEventConfirm,
    TimeTrackerHumanInfoModal,
  },

  computed: {
    // ...mapGetters('HumanUser', ['getColumns']),
    ...mapFields('CalendarDateUserDash', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters']),
  },

  watch: {
    message_error(newValue, oldValue) {
      // console.log('watch loading', newValue, oldValue, this.message_error)
      if (newValue)
        this.snackbar = true
      }
  },

  methods: {
    ...mapActions('CalendarDateUserDash', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    actionWorkingEvent(item, event) {
      console.log('actionWorkingEvent', item, event)
      item.last_status = event
      let params = {
        action_name: 'working_event',
        parameters: {
          event: event,
          user: item.human_user.id,
        },
        id_list: [item.id],
      }
      this.fetchActionItem(params);
    },

    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      // console.log(this.$refs)
      let topHeight = 10
      if (this.$refs.RefListTop)
        topHeight = this.$refs.RefListTop.$el.clientHeight
      let footerHeight = 10
      if (this.$refs.RefListFooter)
        footerHeight = this.$refs.RefListFooter.clientHeight
      this.windowHeight = (window.innerHeight - this.subtractHeight - topHeight - footerHeight) + "px"
      // console.log('this.windowHeight', this.windowHeight)
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.event === 'working')
        return 'row_started'
      if (item.event === 'pause')
        return 'row_pause_started'
      return
    },

    updateOptions() {
      // console.log('updateOptions')
      const currentDate = new Date().toISOString().slice(0, 10)

      this.filters = {
        from_date: currentDate,
        to_date: currentDate,
      }
      if (this.loading === false)
        this.fetchItemList({to_consumer: 'CalendarDateUserTrackerDTO', from_consumer: 'CalendarDateUserTrackerDTO'})
    },

    statusColor() {
      if (this.search_status === 'OK')
        return 'success'
      if (this.search_status === 'NOK')
        return 'error'
      return 'primary'
    },

    filteredItems() {
      self = this
      let today = new Date().toISOString().slice(0, 10)
      return this.itemList.filter( item =>
          item.human_user.floor === self.floor &&
          item.human_user.visible &&
          item.human_user.active &&
          item.calendar_date.dt === today
      )
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
    this.onResize()
  },

  created() {
    window.addEventListener("resize", this.onResize);

    // update the time every second
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval)
  },

  data() {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
      search: '',
      columns: [
        {text: 'E/N', value: 'employee_number', sortable: false, divider: false, brief: true,},
        {text: 'User', value: 'user', sortable: false, filterable: true, divider: false, brief: true,},
        // {text: 'Event', value: 'event', sortable: false, divider: false, brief: true,},
        {text: '', value: 'start', sortable: false, divider: false, brief: true,},
        {text: '', value: 'pause', sortable: false, divider: false, brief: true,},
    ],
      snackbar: false,
      timeout: 15000,
    }
  }
}
</script>

<style>
tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }

.row_started {
  background-color: #E8F5E9 !important;
}
.row_pause_started {
  background-color: #FFFDE7 !important;
}
.row_empty {
  background-color: white !important;
}

</style>
